import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { Redirect, useParams } from 'react-router-dom'

import { verifyEmail, resendEmail  } from '../../redux/actions/auth'
import { ReactComponent as LogoImg } from '../../assets/svg/logo.svg'
import { ReactComponent as EmailEnvelop } from '../../assets/svg/email-envelop.svg'

const VerifyPage = () => {
  const dispatch = useDispatch()

  const [isVerified, setIsVerified] = useState(false)
  const { email, hash } = useParams()

  const handleResendEmail = () => {
    dispatch(
      resendEmail(email)
    )
  }

  const handleVerifyEmail = () => {
    dispatch(
      verifyEmail(hash)
    ).then(() => {
      setIsVerified(true)
    }).catch(() => {
      setIsVerified(false)
    })
  }
  if (isVerified) {
    return <Redirect to='/login' />
  }
  return (
    <div className="verify-page">
      <div className='site-logo'>
        <LogoImg/>
      </div>
      
      <div className="content">
        <div className='email-envelop'>
          <EmailEnvelop/>
        </div>
        <div className="title">
          {/* <h2>Email Verification</h2> */}
          Verify your email
          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec velit erat, consequat non lacinia eget, </p>
        </div>
        <div className="action">
          <button type="button" className="verify-email-btn btn" onClick={handleVerifyEmail}>
            Verify
          </button>
          {
            !isVerified && (
              <button type="button" className="btn resend-email-btn" onClick={handleResendEmail}>
                Resend Code
              </button>
            )
          }
        </div>
      </div>
    </div>
  )
}
export default VerifyPage